import { combineReducers } from 'redux';

import evaluationsUiReducer from './evaluationsUiReducer';
import evaluationsDataReducer from './evaluationsDataReducer';

export default combineReducers({
  ui: evaluationsUiReducer,
  data: evaluationsDataReducer,
});
